import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { fetchData, handleTimeChange, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddRestaurantHeader } from './AddRestaurantHeader';
import moment from 'moment';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { Tr } from '../../../_metronic/i18n/Tr';

const AddRestaurantPolicies: FC = () => {

    const t = Tr()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId');
    useEffect(() => {
        if (categoryId != '3') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const editRestaurantId = (location.state as any)?.restaurantId || '';
    const primaryLanguage = localStorage.getItem("primaryLanguage");
    const [restaurantDetails, setRestaurantDetails] = useState([]);

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
        console.log("No vendor data found");
    }

    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [additionalInformationEN, setAdditionalInformationEN] = useState("");
    const [additionalInformationRU, setAdditionalInformationRU] = useState("");
    const [additionalInformationUZ, setAdditionalInformationUZ] = useState("");
    const [showPolicy, setShowPolicy] = useState(false);

    const togglePolicy = () => {
        setShowPolicy(!showPolicy);
    }

    const [policies, setPolicies] = useState([
        { en_title: '', ru_title: '', uz_title: '', en_description: '', ru_description: '', uz_description: '' }
    ])

    // set error state
    const [error, setError] = useState([{

        additionalInformationEN: '',
        additionalInformationRU: '',
        additionalInformationUZ: '',
    }])

    const [errors, setErrors] = useState({
        titleEN: '',
        titleRU: '',
        titleUZ: '',
        descriptionEN: '',
        descriptionRU: '',
        descriptionUZ: '',
    }) as any;

    const handleAddPolicy = () => {
        setPolicies([...policies, { en_title: '', ru_title: '', uz_title: '', en_description: '', ru_description: '', uz_description: '' }]);
    };

    const handleRemovePolicy = (index: any) => {
        if (policies.length === 1) return; // Prevent removing the last row
        setPolicies(policies.filter((_, i) => i !== index));
        // Errors are keyed by row index, so drop the removed row and shift the rest down
        const updatedErrors = {} as any;
        Object.keys(errors).forEach((key) => {
            const i = Number(key);
            if (i < index) updatedErrors[i] = errors[key];
            else if (i > index) updatedErrors[i - 1] = errors[key];
        });
        setErrors(updatedErrors);
    };

    const handlePolicyChange = (index: any, field: any, value: any) => {
        // Replace the row instead of mutating it in place
        setPolicies(policies.map((policy, i) => (i === index ? { ...policy, [field]: value } : policy)) as any);
        // Clear error when user starts typing
        const updatedErrors = { ...errors } as any;
        delete updatedErrors[index];
        setErrors(updatedErrors);
    };

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }
    // validation function
    const validate = () => {

        var isValid = true;
        // Start from a clean slate so errors the user already fixed disappear
        var errorTmp = [{ additionalInformationEN: '', additionalInformationRU: '', additionalInformationUZ: '' }];

        if (primaryLanguage == "English") {

            if (additionalInformationEN.trim() == "" || additionalInformationEN.trim() == null || additionalInformationEN.trim() == undefined) {
                errorTmp[0].additionalInformationEN = t('Additional Information Is Required');
                isValid = false;
            }
        } else if (primaryLanguage == "Russian") {
            if (additionalInformationRU.trim() == "" || additionalInformationRU.trim() == null || additionalInformationRU.trim() == undefined) {
                errorTmp[0].additionalInformationRU = t('Additional Information Is Required');
                isValid = false;
            }
        } else if (primaryLanguage == "Uzbek") {

            if (additionalInformationUZ.trim() == "" || additionalInformationUZ.trim() == null || additionalInformationUZ.trim() == undefined) {
                errorTmp[0].additionalInformationUZ = t('Additional Information Is Required');
                isValid = false;
            }
        }

        if (showPolicy) {
            const newErrors = {} as any;
            policies.forEach((policy: any, index: any) => {
                if (primaryLanguage == "English") {
                    if (!policy.en_title) {
                        newErrors[index] = { ...newErrors[index], titleEN: t('Policy Title Is Required') };
                        isValid = false;
                    }
                    if (!policy.en_description) {
                        newErrors[index] = { ...newErrors[index], descriptionEN: t('Description Is Required') };
                        isValid = false;
                    }
                } else if (primaryLanguage == "Russian") {
                    if (!policy.ru_title) {
                        newErrors[index] = { ...newErrors[index], titleRU: t('Policy Title Is Required') };
                        isValid = false;
                    }
                    if (!policy.ru_description) {
                        newErrors[index] = { ...newErrors[index], descriptionRU: t('Description Is Required') };
                        isValid = false;
                    }
                } else if (primaryLanguage == "Uzbek") {
                    if (!policy.uz_title) {
                        newErrors[index] = { ...newErrors[index], titleUZ: t('Policy Title Is Required') };
                        isValid = false;
                    }
                    if (!policy.uz_description) {
                        newErrors[index] = { ...newErrors[index], descriptionUZ: t('Description Is Required') };
                        isValid = false;
                    }
                }
            });
            setErrors(newErrors);
        }
        setError(errorTmp);
        return isValid;
    }

    // '23:45:00' is treated as the end of the day (midnight)
    const DAY_END_MINUTES = 23 * 60 + 45
    const SLOT_LENGTH_MINUTES = 60

    const toMinutes = (time: any) => {
        const parsed = moment(time, ['HH:mm:ss', 'HH:mm'], true)
        return parsed.isValid() ? parsed.hours() * 60 + parsed.minutes() : -1
    }
    const toTimeString = (minutes: number) =>
        `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}:00`

    const makeDefaultSlot = () => ({ startTime: '09:00:00', endTime: '18:00:00' })

    const WEEK_DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']

    const [openingHourData, setOpeningHourData] = useState<any[]>(
        WEEK_DAYS.map((day) => ({ day, isOpen: '0', timeSlot: [] }))
    )
    const [openingHourError, setOpeningHourError] = useState('')

    // Sorts slots by start time so the "add next slot" and overlap checks stay predictable
    const sortSlots = (slots: any[]) => [...slots].sort((a, b) => toMinutes(a.startTime) - toMinutes(b.startTime))

    // Replaces a single day immutably, so React never sees a mutated slot array
    const updateDay = (dayIndex: number, updater: (day: any) => any) => {
        setOpeningHourData((prev: any[]) => prev.map((day, index) => (index === dayIndex ? updater(day) : day)))
        setOpeningHourError('')
    }

    const toggleDayOpen = (dayIndex: number, isOpen: string) => {
        updateDay(dayIndex, (day) => ({
            ...day,
            isOpen: isOpen,
            // open → start with one sensible slot, close → drop every slot
            timeSlot: isOpen == '1' ? (day.timeSlot.length > 0 ? day.timeSlot : [makeDefaultSlot()]) : [],
        }))
    }

    const addTimeField = (dayIndex: number) => {
        const day = openingHourData[dayIndex]
        const slots = sortSlots(day.timeSlot)

        if (slots.length === 0) {
            updateDay(dayIndex, (d) => ({ ...d, isOpen: '1', timeSlot: [makeDefaultSlot()] }))
            return
        }

        // Start the new slot right after the latest one so it never overlaps by default
        const start = toMinutes(slots[slots.length - 1].endTime)
        if (start < 0 || start >= DAY_END_MINUTES) {
            toasterrormsg(t('No Time Left To Add Another Slot'))
            return
        }
        const end = Math.min(start + SLOT_LENGTH_MINUTES, DAY_END_MINUTES)

        updateDay(dayIndex, (d) => ({
            ...d,
            isOpen: '1',
            timeSlot: [...slots, { startTime: toTimeString(start), endTime: toTimeString(end) }],
        }))
    }

    const removeTimeField = (dayIndex: number, timeIndex: number) => {
        updateDay(dayIndex, (day) => {
            const timeSlot = day.timeSlot.filter((_: any, i: number) => i !== timeIndex)
            // No slots left → the day is closed
            return { ...day, timeSlot, isOpen: timeSlot.length === 0 ? '0' : '1' }
        })
    }

    const handleInputChange = (dayIndex: any, timeIndex: any, event: any) => {
        const { name, value } = event.target
        const parsedTime = moment(value, ['HH:mm:ss', 'HH:mm'], true)
        if (!parsedTime.isValid()) return

        let formattedValue = parsedTime.format('HH:mm:ss')
        // Midnight as an end time means "open until the end of the day"
        if (formattedValue == '00:00:00' && name === 'endTime') {
            formattedValue = '23:45:00'
        }

        const day = openingHourData[dayIndex]
        const candidate = { ...day.timeSlot[timeIndex], [name]: formattedValue }
        const start = toMinutes(candidate.startTime)
        const end = toMinutes(candidate.endTime)

        if (end <= start) {
            toasterrormsg(t('End Time Must Be Greater Than Start Time'))
            return
        }

        // Two slots overlap when each one starts before the other ends
        const overlaps = day.timeSlot.some((slot: any, i: number) => {
            if (i === timeIndex) return false
            return start < toMinutes(slot.endTime) && toMinutes(slot.startTime) < end
        })
        if (overlaps) {
            toasterrormsg(t('Time Is Conflicting'))
            return
        }

        updateDay(dayIndex, (d) => ({
            ...d,
            timeSlot: d.timeSlot.map((slot: any, i: number) => (i === timeIndex ? candidate : slot)),
        }))
    }

    // Every open day needs at least one slot, and every slot needs a valid, non-overlapping range
    const validateOpeningHours = () => {
        for (const day of openingHourData) {
            if (day.isOpen != '1') continue

            if (!day.timeSlot || day.timeSlot.length === 0) {
                setOpeningHourError(t('Please Add At Least One Time Slot For Every Open Day'))
                return false
            }

            const slots = sortSlots(day.timeSlot)
            for (let i = 0; i < slots.length; i++) {
                const start = toMinutes(slots[i].startTime)
                const end = toMinutes(slots[i].endTime)
                if (start < 0 || end <= start) {
                    setOpeningHourError(t('End Time Must Be Greater Than Start Time'))
                    return false
                }
                if (i > 0 && start < toMinutes(slots[i - 1].endTime)) {
                    setOpeningHourError(t('Time Is Conflicting'))
                    return false
                }
            }
        }
        setOpeningHourError('')
        return true
    }
    // add hotel policy api call
    const addRestaurantPolicies = async () => {
        const isFormValid = validate()
        const areHoursValid = validateOpeningHours()

        if (!isFormValid || !areHoursValid) {
            toasterrormsg(t('Please Fill In All Required Fields.'))
            return
        }

        setDisable(true)
        setLoading(true)

        var param: any = {
            restaurantId: String(editRestaurantId),
            en_additionalInformation: additionalInformationEN,
            ru_additionalInformation: additionalInformationRU,
            uz_additionalInformation: additionalInformationUZ,
            openinghours: openingHourData
        }
        if (showPolicy) {
            param['customPolicy'] = policies
        }

        try {
            var response: any = await fetchData("public/addRestaurantPolicy", param)

            if (response.status == "200") {
                toastsuccessmsg(t("Policies Added Successfully!"))
                const state = {
                    restaurantId: editRestaurantId
                }
                setTimeout(() => {
                    navigate("../addrestaurantfinance/", { state });
                }, 1500);
            }
            else {
                toasterrormsg(response.message)
                setDisable(false)
                setLoading(false)
            }
        } catch (e) {
            toasterrormsg(t('Something Went Wrong'))
            setDisable(false)
            setLoading(false)
        }
    }
    //   restaurant list api call
    const restaurantDetailApiCall = async () => {

        var param = {
            'vendorId': vendorId,
            'restaurantId': editRestaurantId
        }
        var res = await fetchData("public/restaurantDetail", param)

        if (res.status == "200") {
            var restaurantData = res.data;
            if (!restaurantData || restaurantData.length === 0) return;

            setRestaurantDetails(restaurantData);
            setAdditionalInformationEN(restaurantData[0]["en_additionalInformation"] || "")
            setAdditionalInformationRU(restaurantData[0]["ru_additionalInformation"] || "")
            setAdditionalInformationUZ(restaurantData[0]["uz_additionalInformation"] || "")

            const savedHours = restaurantData[0]['openingHours'] || [];
            if (savedHours.length != 0) {
                const byDay = new Map<string, any>()
                savedHours.forEach((item: any) => {
                    const timeSlot = sortSlots(item.timeSlot || [])
                    byDay.set(String(item.day).toUpperCase(), {
                        openinghourId: item.openinghourId,
                        day: String(item.day).toUpperCase(),
                        timeSlot,
                        // Keep isOpen consistent with the slots the API actually returned
                        isOpen: timeSlot.length > 0 && item.isOpen != '0' ? '1' : '0',
                    })
                })
                // Always render all seven days, in week order, even if the API omits some
                setOpeningHourData(
                    WEEK_DAYS.map((day) => byDay.get(day) || { day, isOpen: '0', timeSlot: [] })
                )
            }
            const savedPolicies = restaurantData[0]["customPolicy"] || [];
            if (savedPolicies.length != 0) {
                setShowPolicy(true)
                setPolicies(savedPolicies)
            }
        }
        else {
            toasterrormsg(res.message)
        }
    }
    useEffect(() => {
        if (editRestaurantId != "") {
            restaurantDetailApiCall();
        }
    }, [])

    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editRestaurantId != "" ? t('Edit Policies') : t('Add Policies')}</PageTitle>
            <AddRestaurantHeader restaurantId={editRestaurantId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">

                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t('Policies')}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        restaurantDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    restaurantDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['propertyDetail']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['menu']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['availability']) {
                                                                            percentage = 80;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-10">
                                                {
                                                    primaryLanguage == "English" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 required form-label">{t('Additional Information (English)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <textarea name="additionalInformationEN" className="form-control mb-2" placeholder={t("Additional Information")} cols={30} rows={4} onChange={(e) => { setAdditionalInformationEN(e.target.value); removeError("additionalInformationEN"); }} value={additionalInformationEN}></textarea>
                                                                    <div className='text-danger fw-bold'>{error[0].additionalInformationEN}</div>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Additional Information (Russian)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <textarea name="additionalInformationRU" className="form-control mb-2" placeholder={t("Additional Information")} cols={30} rows={4} onChange={(e) => { setAdditionalInformationRU(e.target.value) }} value={additionalInformationRU}></textarea>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Additional Information (Uzbek)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <textarea name="additionalInformationUZ" className="form-control mb-2" placeholder={t("Additional Information")} cols={30} rows={4} onChange={(e) => { setAdditionalInformationUZ(e.target.value) }} value={additionalInformationUZ}></textarea>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguage == "Russian" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 required form-label">{t('Additional Information (Russian)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <textarea name="additionalInformationRU" className="form-control mb-2" placeholder={t("Additional Information")} cols={30} rows={4} onChange={(e) => { setAdditionalInformationRU(e.target.value); removeError("additionalInformationRU"); }} value={additionalInformationRU}></textarea>
                                                                    <div className='text-danger fw-bold'>{error[0].additionalInformationRU}</div>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Additional Information (English)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <textarea name="additionalInformationEN" className="form-control mb-2" placeholder={t("Additional Information")} cols={30} rows={4} onChange={(e) => { setAdditionalInformationEN(e.target.value) }} value={additionalInformationEN}></textarea>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Additional Information (Uzbek)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <textarea name="additionalInformationUZ" className="form-control mb-2" placeholder={t("Additional Information")} cols={30} rows={4} onChange={(e) => { setAdditionalInformationUZ(e.target.value) }} value={additionalInformationUZ}></textarea>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguage == "Uzbek" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 required form-label">{t('Additional Information (Uzbek)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <textarea name="additionalInformationUZ" className="form-control mb-2" placeholder={t("Additional Information")} cols={30} rows={4} onChange={(e) => { setAdditionalInformationUZ(e.target.value); removeError("additionalInformationUZ"); }} value={additionalInformationUZ}></textarea>
                                                                    <div className='text-danger fw-bold'>{error[0].additionalInformationUZ}</div>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Additional Information (Russian)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <textarea name="additionalInformationRU" className="form-control mb-2" placeholder={t("Additional Information")} cols={30} rows={4} onChange={(e) => { setAdditionalInformationRU(e.target.value) }} value={additionalInformationRU}></textarea>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Additional Information (English)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <textarea name="additionalInformationEN" className="form-control mb-2" placeholder={t("Additional Information")} cols={30} rows={4} onChange={(e) => { setAdditionalInformationEN(e.target.value) }} value={additionalInformationEN}></textarea>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                <div className="row">
                                                    <div className="border border-2"></div>
                                                    <div className="col-lg-12 my-3">
                                                        <label className="fs-3 form-label fw-bold">{t('Opening Hours')}</label>
                                                    </div>
                                                    <div className="col-lg-12 my-3">
                                                        <span className='fw-bolder fs-5 form-label'>{t('*Note:')}<span className="fs-6 form-label"> {t(`If you don't add 'opening hours' to any days of the week below, that day will be considered as 'Closed', 'Unavailable for bookings'`)}</span></span>
                                                    </div>
                                                </div>
                                                {/* <!--begin::Row--> */}
                                                {openingHourError && (
                                                    <div className="text-danger fw-bold mb-3">{openingHourError}</div>
                                                )}
                                                {openingHourData.map((dayData: any, dayIndex: any) => {
                                                    const isOpen = dayData.isOpen == '1'
                                                    const dayLabel = t(
                                                        dayData.day.charAt(0).toUpperCase() + dayData.day.slice(1).toLowerCase()
                                                    )
                                                    return (
                                                        <div className="row align-items-center border-bottom border-gray-200 py-3" key={dayData.day}>
                                                            <div className="col-6 col-lg-2">
                                                                <h5 className='mb-0'>{dayLabel}</h5>
                                                            </div>
                                                            <div className='col-6 col-lg-2'>
                                                                <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                                                                    <input
                                                                        className='form-check-input cursor-pointer'
                                                                        type='checkbox'
                                                                        id={`openingHourSwitch${dayIndex}`}
                                                                        checked={isOpen}
                                                                        onChange={(e) => toggleDayOpen(dayIndex, e.target.checked ? "1" : "0")}
                                                                    />
                                                                    <label
                                                                        className='form-check-label text-gray-700 fw-bold ms-2'
                                                                        htmlFor={`openingHourSwitch${dayIndex}`}
                                                                        title={isOpen ? t('Currently Open') : t('Currently Closed')}
                                                                    >
                                                                        {isOpen ? t('Open') : t('Closed')}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-lg-8 mt-3 mt-lg-0">
                                                                {!isOpen ? (
                                                                    <span className="text-muted fst-italic">
                                                                        {t('Closed - Unavailable For Bookings')}
                                                                    </span>
                                                                ) : (
                                                                    dayData.timeSlot.map((timeSlot: any, timeIndex: any) => (
                                                                        <div className={`row align-items-end ${timeIndex > 0 ? 'mt-3' : ''}`} key={timeIndex}>
                                                                            <div className="col-6 col-lg-5">
                                                                                {/* Labels only on the first slot so stacked slots stay compact */}
                                                                                {timeIndex === 0 && (
                                                                                    <label className="fs-6 form-label required mb-1">{t('Start Time')}</label>
                                                                                )}
                                                                                <Flatpickr
                                                                                    value={moment(timeSlot.startTime, ['HH:mm:ss', 'HH:mm']).format('HH:mm')}
                                                                                    onChange={(date) => {
                                                                                        const formattedTime = handleTimeChange(date);
                                                                                        handleInputChange(dayIndex, timeIndex, { target: { name: 'startTime', value: formattedTime } });
                                                                                    }}
                                                                                    options={{
                                                                                        enableTime: true,        // Enable time selection
                                                                                        noCalendar: true,        // Hide the date picker, only show time
                                                                                        dateFormat: 'H:i',       // 24-hour format (H:i)
                                                                                        time_24hr: true,         // Enforces 24-hour format
                                                                                        minuteIncrement: 15,     // 15-minute increments in dropdown
                                                                                        allowInput: false,       // Selection only, no free typing
                                                                                    }}
                                                                                    className="form-control form-control-sm"
                                                                                />
                                                                            </div>
                                                                            <div className="col-6 col-lg-5">
                                                                                {timeIndex === 0 && (
                                                                                    <label className="fs-6 form-label required mb-1">{t('End Time')}</label>
                                                                                )}
                                                                                <Flatpickr
                                                                                    value={moment(timeSlot.endTime, ['HH:mm:ss', 'HH:mm']).format('HH:mm')}
                                                                                    onChange={(date) => {
                                                                                        const formattedTime = handleTimeChange(date);
                                                                                        handleInputChange(dayIndex, timeIndex, { target: { name: 'endTime', value: formattedTime } });
                                                                                    }}
                                                                                    options={{
                                                                                        enableTime: true,
                                                                                        noCalendar: true,
                                                                                        dateFormat: 'H:i',
                                                                                        time_24hr: true,
                                                                                        minuteIncrement: 15,
                                                                                        allowInput: false,
                                                                                    }}
                                                                                    className="form-control form-control-sm"
                                                                                />
                                                                            </div>
                                                                            <div className="col-12 col-lg-2 d-flex justify-content-end justify-content-lg-start gap-1 mt-2 mt-lg-0">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-danger"
                                                                                    title={t('Remove Time Slot')}
                                                                                    onClick={() => removeTimeField(dayIndex, timeIndex)}
                                                                                >X</button>
                                                                                {/* Only the last slot offers "add", so slots stay in order */}
                                                                                {timeIndex === dayData.timeSlot.length - 1 && (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-sm btn-success"
                                                                                        title={t('Add Time Slot')}
                                                                                        onClick={() => addTimeField(dayIndex)}
                                                                                    >+</button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                })}

                                                {/* <!--end::Row--> */}
                                                <div className="row">
                                                    <div className="border border-2"></div>
                                                    <div className="col-lg-12 my-3">
                                                        <button type="button" className='btn btn-light-success' onClick={togglePolicy}>{t('Add Custom Policy')}</button>
                                                    </div>
                                                </div>

                                                {/* <!--end::Input group--> */}
                                                {
                                                    showPolicy && (
                                                        policies.map((policy, index) => (
                                                            <div className="row" key={index}>
                                                                {
                                                                    primaryLanguage == "English" && (
                                                                        <>
                                                                            <div className="col-lg-12">
                                                                                <div className="row">
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="required fs-4 form-label">{t('Policy Title (English)')}</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="titleEN"
                                                                                            placeholder={t('Policy Title')}
                                                                                            className="form-control mb-2"
                                                                                            value={policy.en_title}
                                                                                            onChange={(e) => handlePolicyChange(index, "en_title", e.target.value)}
                                                                                        />
                                                                                        {errors[index]?.titleEN && <div className="text-danger fw-bold">{errors[index].titleEN}</div>}
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Policy Title (Russian)')}</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="titleRU"
                                                                                            placeholder={t('Policy Title')}
                                                                                            className="form-control mb-2"
                                                                                            value={policy.ru_title}
                                                                                            onChange={(e) => handlePolicyChange(index, "ru_title", e.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className=" fs-4 form-label">{t('Policy Title (Uzbek)')}</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="titleUZ"
                                                                                            placeholder={t('Policy Title')}
                                                                                            className="form-control mb-2"
                                                                                            value={policy.uz_title}
                                                                                            onChange={(e) => handlePolicyChange(index, "uz_title", e.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-lg-2"></div>
                                                                                </div>
                                                                                <div className="row">
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="required fs-4 form-label">{t('Description (English)')}</label>
                                                                                        <textarea
                                                                                            name="descriptionEN"
                                                                                            className="form-control mb-2"
                                                                                            placeholder={t("Description")}
                                                                                            cols={30}
                                                                                            rows={4}
                                                                                            value={policy.en_description}
                                                                                            onChange={(e) => handlePolicyChange(index, "en_description", e.target.value)}
                                                                                        ></textarea>
                                                                                        {errors[index]?.descriptionEN && <div className="text-danger fw-bold">{errors[index].descriptionEN}</div>}
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Description (Russian)')}</label>
                                                                                        <textarea
                                                                                            name="descriptionRU"
                                                                                            className="form-control mb-2"
                                                                                            placeholder={t("Description")}
                                                                                            cols={30}
                                                                                            rows={4}
                                                                                            value={policy.ru_description}
                                                                                            onChange={(e) => handlePolicyChange(index, "ru_description", e.target.value)}
                                                                                        ></textarea>
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Description (Uzbek)')}</label>
                                                                                        <textarea
                                                                                            name="descriptionUZ"
                                                                                            className="form-control mb-2"
                                                                                            placeholder={t("Description")}
                                                                                            cols={30}
                                                                                            rows={4}
                                                                                            value={policy.uz_description}
                                                                                            onChange={(e) => handlePolicyChange(index, "uz_description", e.target.value)}
                                                                                        ></textarea>
                                                                                    </div>
                                                                                    <div className="col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3">
                                                                                        {index !== 0 && (
                                                                                            <button type="button" className="btn btn-danger mb-2 me-1" onClick={() => handleRemovePolicy(index)}>X</button>
                                                                                        )}
                                                                                        <button type="button" className="btn btn-success mb-2" onClick={handleAddPolicy}>+</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }
                                                                {
                                                                    primaryLanguage == "Russian" && (
                                                                        <>
                                                                            <div className="col-lg-12">
                                                                                <div className="row">
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="required fs-4 form-label">{t('Policy Title (Russian)')}</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="titleRU"
                                                                                            placeholder={t('Policy Title')}
                                                                                            className="form-control mb-2"
                                                                                            value={policy.ru_title}
                                                                                            onChange={(e) => handlePolicyChange(index, "ru_title", e.target.value)}
                                                                                        />
                                                                                        {errors[index]?.titleRU && <div className="text-danger fw-bold">{errors[index].titleRU}</div>}
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Policy Title (English)')}</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="titleEN"
                                                                                            placeholder={t('Policy Title')}
                                                                                            className="form-control mb-2"
                                                                                            value={policy.en_title}
                                                                                            onChange={(e) => handlePolicyChange(index, "en_title", e.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Policy Title (Uzbek)')}</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="titleUZ"
                                                                                            placeholder={t('Policy Title')}
                                                                                            className="form-control mb-2"
                                                                                            value={policy.uz_title}
                                                                                            onChange={(e) => handlePolicyChange(index, "uz_title", e.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-lg-2"></div>
                                                                                </div>
                                                                                <div className="row">
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="required fs-4 form-label">{t('Description (Russian)')}</label>
                                                                                        <textarea
                                                                                            name="descriptionRU"
                                                                                            className="form-control mb-2"
                                                                                            placeholder={t("Description")}
                                                                                            cols={30}
                                                                                            rows={4}
                                                                                            value={policy.ru_description}
                                                                                            onChange={(e) => handlePolicyChange(index, "ru_description", e.target.value)}
                                                                                        ></textarea>
                                                                                        {errors[index]?.descriptionRU && <div className="text-danger fw-bold">{errors[index].descriptionRU}</div>}
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Description (English)')}</label>
                                                                                        <textarea
                                                                                            name="descriptionEN"
                                                                                            className="form-control mb-2"
                                                                                            placeholder={t("Description")}
                                                                                            cols={30}
                                                                                            rows={4}
                                                                                            value={policy.en_description}
                                                                                            onChange={(e) => handlePolicyChange(index, "en_description", e.target.value)}
                                                                                        ></textarea>
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Description (Uzbek)')}</label>
                                                                                        <textarea
                                                                                            name="descriptionUZ"
                                                                                            className="form-control mb-2"
                                                                                            placeholder={t("Description")}
                                                                                            cols={30}
                                                                                            rows={4}
                                                                                            value={policy.uz_description}
                                                                                            onChange={(e) => handlePolicyChange(index, "uz_description", e.target.value)}
                                                                                        ></textarea>
                                                                                    </div>
                                                                                    <div className="col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3">
                                                                                        {index !== 0 && (
                                                                                            <button type="button" className="btn btn-danger mb-2 me-1" onClick={() => handleRemovePolicy(index)}>X</button>
                                                                                        )}
                                                                                        <button type="button" className="btn btn-success mb-2" onClick={handleAddPolicy}>+</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }
                                                                {
                                                                    primaryLanguage == "Uzbek" && (
                                                                        <>
                                                                            <div className="col-lg-12">
                                                                                <div className="row">
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label required">{t('Policy Title (Uzbek)')}</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="titleUZ"
                                                                                            placeholder={t('Policy Title')}
                                                                                            className="form-control mb-2"
                                                                                            value={policy.uz_title}
                                                                                            onChange={(e) => handlePolicyChange(index, "uz_title", e.target.value)}
                                                                                        />
                                                                                        {errors[index]?.titleUZ && <div className="text-danger fw-bold">{errors[index].titleUZ}</div>}
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className=" fs-4 form-label">{t('Policy Title (Russian)')}</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="titleRU"
                                                                                            placeholder={t('Policy Title')}
                                                                                            className="form-control mb-2"
                                                                                            value={policy.ru_title}
                                                                                            onChange={(e) => handlePolicyChange(index, "ru_title", e.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Policy Title (English)')}</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            name="titleEN"
                                                                                            placeholder={t('Policy Title')}
                                                                                            className="form-control mb-2"
                                                                                            value={policy.en_title}
                                                                                            onChange={(e) => handlePolicyChange(index, "en_title", e.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-lg-2"></div>
                                                                                </div>
                                                                                <div className="row">
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="required fs-4 form-label">{t('Description (Uzbek)')}</label>
                                                                                        <textarea
                                                                                            name="descriptionUZ"
                                                                                            className="form-control mb-2"
                                                                                            placeholder={t("Description")}
                                                                                            cols={30}
                                                                                            rows={4}
                                                                                            value={policy.uz_description}
                                                                                            onChange={(e) => handlePolicyChange(index, "uz_description", e.target.value)}
                                                                                        ></textarea>
                                                                                        {errors[index]?.descriptionUZ && <div className="text-danger fw-bold">{errors[index].descriptionUZ}</div>}
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Description (Russian)')}</label>
                                                                                        <textarea
                                                                                            name="descriptionRU"
                                                                                            className="form-control mb-2"
                                                                                            placeholder={t("Description")}
                                                                                            cols={30}
                                                                                            rows={4}
                                                                                            value={policy.ru_description}
                                                                                            onChange={(e) => handlePolicyChange(index, "ru_description", e.target.value)}
                                                                                        ></textarea>
                                                                                    </div>
                                                                                    <div className="col-lg my-3">
                                                                                        <label className="fs-4 form-label">{t('Description (English)')}</label>
                                                                                        <textarea
                                                                                            name="descriptionEN"
                                                                                            className="form-control mb-2"
                                                                                            placeholder={t("Description")}
                                                                                            cols={30}
                                                                                            rows={4}
                                                                                            value={policy.en_description}
                                                                                            onChange={(e) => handlePolicyChange(index, "en_description", e.target.value)}
                                                                                        ></textarea>
                                                                                    </div>
                                                                                    <div className="col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3">
                                                                                        {index !== 0 && (
                                                                                            <button type="button" className="btn btn-danger mb-2 me-1" onClick={() => handleRemovePolicy(index)}>X</button>
                                                                                        )}
                                                                                        <button type="button" className="btn btn-success mb-2" onClick={handleAddPolicy}>+</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                        ))
                                                    )
                                                }
                                            </div>
                                            {/* <!--end::Card body--> */}
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                                {/* <!--begin::Button--> */}
                                <button type="button" disabled={disable} className="btn btn-primary" onClick={addRestaurantPolicies}>
                                    <span className="indicator-label">{t('Next')}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddRestaurantPolicies }
